import { Item } from "dsabp-js"
import { rendererResolvers } from "../main.js"
import { getImage } from "../util.js"

rendererResolvers.push(
	({ toRel, item }) => {
		if (item != Item.HELM_STARTER && item != Item.HELM)
			return

		return {
			discriminator: `${item.id}`,
			async render() {
				const img = await getImage(item.buildInfo[0].image)
				return [{
					image: img,
					textureSizeOff: toRel(8, 4),
					texturePosOff: toRel(-4, -2),
					...(item == Item.HELM_STARTER ? {
						sx: 6,
						sy: 6,
						sw: img.width - 12,
						sh: img.height - 12
					} : null)
				}]
			}
		}
	}
)
